import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  setarPago(event) {
    if (!event.target.value) return
    const pago = this.element.querySelector("input[type='checkbox'][name*='[pago]']")
    if (pago && !pago.checked) pago.checked = true
  }
}
